import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {CompanyService} from '@services/company.service';
import {ICompanyCertification, ICompanyUserFile} from '@models/workspace.interface';
import {NotificationService} from '@services/frontend/notification.service';
import {httpErrorMessage} from 'app/utils/http-error.utils';

@Component({
  selector: 'app-company-certifications',
  imports: [DatePipe],
  templateUrl: './company-certifications.html',
})
export class CompanyCertifications implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly companyService = inject(CompanyService);
  private readonly notificationService = inject(NotificationService);

  files = signal<ICompanyUserFile[]>([]);
  apiCertifications = signal<ICompanyCertification[]>([]);
  uploading = signal(false);
  loading = signal(true);
  private siret = '';

  ngOnInit() {
    this.siret = this.route.parent!.snapshot.paramMap.get('siret')!;
    this.refresh();
  }

  refresh() {
    this.loading.set(true);
    this.companyService.listUserFiles(this.siret, 'CERTIFICATION').subscribe({
      next: (f) => this.files.set(f),
      error: () => this.notificationService.error('Impossible de charger les certifications', 3000),
    });
    this.companyService.getCertifications(this.siret).subscribe({
      next: (certifications) => {
        this.apiCertifications.set(certifications);
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.notificationService.error('Impossible de recuperer les certifications publiques', 3000);
      },
    });
  }

  onFileSelected(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) {
      return;
    }
    this.uploading.set(true);
    this.companyService.uploadUserFile(this.siret, file, 'CERTIFICATION').subscribe({
      next: () => {
        this.uploading.set(false);
        this.notificationService.success('Certification envoyée', 2500);
        this.refresh();
      },
      error: (err) => {
        this.uploading.set(false);
        this.notificationService.error(httpErrorMessage(err, 'Échec de l’envoi du fichier'), 5000);
      },
    });
  }

  download(file: ICompanyUserFile) {
    this.companyService.downloadUserFile(this.siret, file.id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.originalFilename;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => this.notificationService.error('Téléchargement impossible', 3000),
    });
  }
}
